import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c4f6d4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "levels-graph" }
const _hoisted_2 = { class: "levels-graph__list" }
const _hoisted_3 = { class: "level__percent" }
const _hoisted_4 = { class: "levels-graph__circle-list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "levels-graph__line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (level) => {
        return (_openBlock(), _createElementBlock("li", {
          key: level,
          class: _normalizeClass({'level': true, 'level--active': level.isActive})
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(level.percent) + "% ", 1)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (level) => {
        return (_openBlock(), _createElementBlock("li", {
          key: level,
          class: _normalizeClass({'circle': true, 'circle--active': level.isActive})
        }, null, 2))
      }), 128))
    ]),
    _hoisted_5
  ]))
}